import { jsxs as t, jsx as e } from "react/jsx-runtime";
import { CircleDollar as i } from "@pelando/fontawesome/icons";
import { Icon as m } from "../Icon/index.js";
import { useTranslation as n } from "../../hooks/useTranslation/index.js";
import { Container as c } from "./style.js";
const x = ({ ...o }) => {
  const { t: r } = n("common");
  return /* @__PURE__ */ t(c, { ...o, children: [
    /* @__PURE__ */ e(m, { icon: i }),
    r("best-price-badge-text")
  ] });
};
export {
  x as BestPriceBadge
};
